import React, { useEffect, useState } from 'react';
import styles from "../MetaField.module.scss";
import { TextField } from '@mui/material';
import { CustomDropdown } from 'components/shared/customDropdown';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useDispatch, useSelector } from 'react-redux';
import { setDroppedItems } from '@redux/slices/triggerSlice';
import { setPublish } from '@redux/slices/globalSlice';

const options = [
    {
        label: "contains",
        value: "contains"
    }
];

const Field = ({
    item
}) => {
    const { triggerDroppedList } = useSelector((state) => state?.trigger);
    const [localOptions, setLocalOptions] = useState(item?.trigger || { label: "Any Field", options: item?.operator || "contains", value: item?.value || [] });

    const dispatch = useDispatch();

    // Handle changes and ensure value is always an array
    const handleChange = (name, value) => {
        setLocalOptions((prev) => {
            let updatedOptions = { ...prev, [name]: value };

            // Make sure value is always an array
            if (name === "value") {
                updatedOptions.value = Array.isArray(value) ? value : [value]; // Ensure value is an array
            }

            return updatedOptions;
        });
    };

    const handleDelete = () => {
        const filteredDroppedItems = triggerDroppedList?.filter((e) => e?.id !== item?.id);
        dispatch(setDroppedItems(filteredDroppedItems));
        dispatch(setPublish(true))
    };

    useEffect(() => {
        const updatedTriggerList = triggerDroppedList?.map((e) => {
            if (e?.id === item?.id) {
                return {
                    ...e,
                    trigger: { ...localOptions },
                };
            }
            return e;
        });
        dispatch(setDroppedItems(updatedTriggerList));
    }, [localOptions]);
    useEffect(() => {
        setLocalOptions((prev) => ({
            ...prev,
            options: item?.operator || prev.options,
            value: item?.value || prev?.value
        }));
    }, [item?.operator, item?.value]);

    return (
        <>
            <div className={styles?.metaContainer}>
                <div className={styles?.field}>
                    <TextField value={"Any Field"} disabled={true} />
                    <CustomDropdown
                        options={options}
                        width='200px'
                        isDisabled={true}
                        value={"contains"}
                        onChange={(e) => {
                            handleChange(e?.target?.name, e?.target.value);
                        }}
                        name="options"
                    />
                    <TextField
                        name='value'
                        onChange={(e) => handleChange(e?.target?.name, e?.target.value)}
                        value={localOptions?.value[0] || ""} // Get the first element of the array (if it exists)
                    />
                </div>

                <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={handleDelete}>
                    <HighlightOffIcon />
                </div>
            </div>
        </>
    );
}

export default Field;
